<svg
  version="1.1"
  id="Artwork"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  x="0px"
  y="0px"
  viewBox="0 0 215.5 154.3"
  style="enable-background: new 0 0 215.5 154.3"
  xml:space="preserve"
>
  <g>
    <path
      id="XMLID_4_"
      d="M175.7,24.2H39.8c-0.6,0-1.1,0-1.7,0c-0.5,0-1,0-1.4,0c-1,0-2.1,0.1-3.1,0.3c-1,0.2-2,0.5-3,1
		c-0.9,0.4-1.8,1.1-2.5,1.8c-0.7,0.7-1.4,1.6-1.8,2.5c-0.5,0.9-0.8,1.9-1,3c-0.2,1-0.2,2.1-0.3,3.1c0,0.5,0,1,0,1.4
		c0,0.6,0,1.1,0,1.7v76.3c0,0.6,0,1.1,0,1.7c0,0.5,0,1,0,1.4c0,1,0.1,2.1,0.3,3.1c0.2,1,0.5,2,1,3c0.5,0.9,1.1,1.8,1.8,2.5
		c0.7,0.7,1.6,1.4,2.5,1.8c0.9,0.5,1.9,0.8,3,1c1,0.2,2.1,0.2,3.1,0.3c0.5,0,1,0,1.4,0c0.6,0,1.1,0,1.7,0h135.9c0.6,0,1.1,0,1.7,0
		c0.5,0,1,0,1.4,0c1,0,2.1-0.1,3.1-0.3c1-0.2,2-0.5,3-1c0.9-0.5,1.8-1.1,2.5-1.8c0.7-0.7,1.4-1.6,1.8-2.5c0.5-0.9,0.8-1.9,1-3
		c0.2-1,0.2-2.1,0.3-3.1c0-0.5,0-1,0-1.4c0-0.6,0-1.1,0-1.7V39c0-0.6,0-1.1,0-1.7c0-0.5,0-1,0-1.4c0-1-0.1-2.1-0.3-3.1s-0.5-2-1-3
		c-0.5-0.9-1.1-1.8-1.8-2.5c-0.7-0.7-1.6-1.4-2.5-1.8c-0.9-0.5-1.9-0.8-3-1c-1-0.2-2.1-0.2-3.1-0.3c-0.5,0-1,0-1.4,0
		C176.8,24.2,176.3,24.2,175.7,24.2L175.7,24.2z"
    />
    <path
      id="XMLID_3_"
      class="st0"
      d="M175.7,27.7h1.7c0.5,0,0.9,0,1.4,0c0.8,0,1.7,0.1,2.6,0.2c0.8,0.1,1.4,0.3,2,0.6
		c0.6,0.3,1.1,0.7,1.6,1.2s0.9,1,1.2,1.6s0.5,1.2,0.6,2c0.2,0.9,0.2,1.8,0.2,2.6c0,0.4,0,0.9,0,1.4c0,0.6,0,1.1,0,1.7v76.3
		c0,0.6,0,1.1,0,1.7c0,0.4,0,0.9,0,1.4c0,0.8-0.1,1.7-0.2,2.6c-0.1,0.7-0.3,1.4-0.6,2s-0.7,1.1-1.2,1.6s-1,0.9-1.6,1.2
		c-0.6,0.3-1.2,0.5-2,0.6c-0.9,0.2-1.8,0.2-2.6,0.2c-0.5,0-0.9,0-1.4,0c-0.6,0-1.1,0-1.7,0H39.8l0,0c-0.5,0-1.1,0-1.7,0
		c-0.5,0-0.9,0-1.4,0c-0.7,0-1.7-0.1-2.6-0.2c-0.7-0.1-1.4-0.3-2-0.7c-0.6-0.3-1.1-0.7-1.6-1.2s-0.9-1-1.2-1.6
		c-0.3-0.6-0.5-1.2-0.6-2c-0.2-0.9-0.2-1.8-0.2-2.6c0-0.5,0-0.9,0-1.4v-1.3v-0.4V39v-0.4v-1.3c0-0.5,0-0.9,0-1.4
		c0-0.8,0.1-1.7,0.2-2.6c0.1-0.7,0.3-1.4,0.6-2c0.3-0.6,0.7-1.1,1.2-1.6s1-0.9,1.6-1.2c0.6-0.3,1.2-0.5,2-0.6
		c0.9-0.2,1.8-0.2,2.6-0.2c0.5,0,0.9,0,1.4,0h1.7L175.7,27.7"
    />
    <g>
      <g>
        <path
          d="M70.2,59.8c1.4-1.8,2.4-4.2,2.1-6.6c-2.1,0.1-4.6,1.4-6.1,3.1c-1.3,1.5-2.5,4-2.2,6.3C66.4,62.9,68.7,61.6,70.2,59.8"
        />
        <path
          d="M72.3,63.2c-3.4-0.2-6.3,1.9-7.9,1.9c-1.6,0-4.1-1.8-6.8-1.8c-3.5,0.1-6.7,2-8.5,5.2c-3.6,6.3-1,15.6,2.6,20.7
				c1.7,2.5,3.8,5.3,6.5,5.2c2.6-0.1,3.6-1.7,6.7-1.7c3.1,0,4,1.7,6.8,1.6s4.6-2.5,6.3-5.1c2-2.9,2.8-5.7,2.8-5.8
				c-0.1-0.1-5.5-2.1-5.5-8.3c-0.1-5.2,4.2-7.7,4.4-7.8C77.4,63.7,73.6,63.3,72.3,63.2"
        />
      </g>
      <g>
        <path
          d="M101.7,56.1c7.4,0,12.5,5.1,12.5,12.4c0,7.4-5.2,12.5-12.7,12.5h-8.1v12.9h-5.9V56.1H101.7L101.7,56.1z M93.4,76.1h6.7
				c5.1,0,8-2.8,8-7.5c0-4.8-2.9-7.5-8-7.5h-6.8v15H93.4z"
        />
        <path
          d="M115.7,86.2c0-4.8,3.7-7.8,10.3-8.2l7.6-0.4v-2.1c0-3.1-2.1-4.9-5.5-4.9c-3.3,0-5.3,1.6-5.8,4h-5.4
				c0.3-5,4.6-8.7,11.4-8.7c6.7,0,11,3.5,11,9.1v19h-5.4v-4.5h-0.1c-1.6,3.1-5.1,5-8.7,5C119.5,94.5,115.7,91.1,115.7,86.2z
				 M133.6,83.7v-2.2l-6.8,0.4c-3.4,0.2-5.3,1.7-5.3,4.1c0,2.4,2,4,5,4C130.5,90,133.6,87.3,133.6,83.7z"
        />
        <path
          d="M144.3,104.2v-4.6c0.4,0.1,1.4,0.1,1.8,0.1c2.6,0,4-1.1,4.9-3.9c0-0.1,0.5-1.7,0.5-1.7l-10-27.6h6.1l7,22.5h0.1l7-22.5h6
				l-10.3,29.1c-2.4,6.7-5.1,8.8-10.8,8.8C146.2,104.3,144.8,104.3,144.3,104.2z"
        />
      </g>
    </g>
  </g>
</svg>
